import { useLazyQuery } from '@apollo/client';

import { TransferDetailsCanSendMoneyInstantlyDocument } from './graphql/canSendMoneyInstantly.gql';

const useInstantScte = () => {
  const [canSendMoneyInstantly, { loading: canSendMoneyInstantlyIsLoading }] =
    useLazyQuery(TransferDetailsCanSendMoneyInstantlyDocument);

  return {
    canSendMoneyInstantly,
    canSendMoneyInstantlyIsLoading,
  };
};

export default useInstantScte;
